import { z } from "zod";

export type CompanySettings = z.infer<typeof companySettingsSchema>;
//export type FieldVisibility = z.infer<typeof FieldVisibilityEnum>;

export enum FieldVisibility {
  REQUIRED = "REQUIRED",
  OPTIONAL = "OPTIONAL",
  HIDDEN = "HIDDEN",
}

export enum InvoiceSpecificationType {
  NO_SPECIFICATION = "NO_SPECIFICATION",
  SPLIT_ON_VEHICLE_REGISTRATION_NUMBER = "SPLIT_ON_VEHICLE_REGISTRATION_NUMBER",
  SPLIT_ON_EMPLOYEE = "SPLIT_ON_EMPLOYEE",
}

const FieldVisibilityEnum = z.enum([
  FieldVisibility.HIDDEN,
  FieldVisibility.OPTIONAL,
  FieldVisibility.REQUIRED,
]);
const InvoiceSpecificationEnum = z.enum([
  InvoiceSpecificationType.NO_SPECIFICATION,
  InvoiceSpecificationType.SPLIT_ON_VEHICLE_REGISTRATION_NUMBER,
  InvoiceSpecificationType.SPLIT_ON_EMPLOYEE,
]);

const companySettingsSchema = z.object({
  regNumberField: FieldVisibilityEnum,
  noteField: FieldVisibilityEnum,
  invoiceSpecification: InvoiceSpecificationEnum,
});
